import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

const getVideoUrl = (url) => {
  if (!url) return '';
  const youtubeParts = url.match(/.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=)([^#]*).*/);

  if (!youtubeParts) return '';

  const youtubeId = youtubeParts[1];
  return `https://www.youtube.com/embed/${youtubeId}?enablejsapi=1&version=3&playerapiid=ytplayer`;
};

export default function Video({ item }) {
  const video = getVideoUrl(get(item, 'embed.embed_url'));

  if (!video) {
    return false;
  }

  return (
    <div className="blog-video-container">
      <iframe
        scrolling="no"
        frameBorder="0"
        src={video}
        loading="lazy"
      />
    </div>
  );
}

Video.propTypes = {
  item: PropTypes.shape({}).isRequired,
};
